exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loading {\n  margin: 25% 0 0 45% !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/jenkins/hornbillfx-elms-v2/src/app/login-akku/login-akku.component.scss
// module id = ../../../../../src/app/login-akku/login-akku.component.scss
// module chunks = main